module.exports = __webpack_public_path__ + "img/gargoyle_geiz.8327af1e.png";